import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "p-head-title" }
const _hoisted_2 = { class: "font-size-12-400 text-center" }
const _hoisted_3 = {
  key: 1,
  class: "avatar-container__initials primary-background-button-color"
}
const _hoisted_4 = { class: "p-text-sm" }

import {computed, reactive} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {servicesService} from '@/api/services/service';
import {useSettingsStore} from '@/api/store/settings';
import {useCartStore} from '@/api/store/cart';
import ButtonBase from "@/components/custom/ButtonBase.vue";
import Icon from "@/components/Icons/Icon.vue";
import {getInitials} from "@/components/Helpers/Utils.ts";

const SUPPLIER_INDEX = null; //null = clinic shop


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceView',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const settingsStore = useSettingsStore();
const cartStore = useCartStore();

const state = reactive({
  service: null as any | null,
});

const loadService = async () => {
  
  let serviceId = Number(route.params.id);
  state.service = await servicesService.getService(serviceId);
  
};

loadService();

const addService = () => {
  
  cartStore.addItem(SUPPLIER_INDEX, state.service.id, 1, "App\\Models\\v3\\ClinicService").then((res) => {
    console.log(res);
    router.push({name: 'shopping-cart'});
  }).catch((error) => {
    settingsStore.error = true;
    settingsStore.error_message = "This item may be out of stock or no longer available from the supplier."
  });
};

const getImage = computed(() => {
  if (!state.service.image && !state.service.image?.file) return null;

  return state.service.image?.file?.file_path;
})

const getDuration = computed(() => {
  return state.service?.booking_options?.duration ?? 0;
})

const getCreatorDetails = computed(() => {
  return state.service?.creator ?? null;
})

return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (state.service)
    ? (_openBlock(), _createBlock(_component_v_container, { key: 0 }, {
        default: _withCtx(() => [
          (getImage.value)
            ? (_openBlock(), _createBlock(_component_v_sheet, {
                key: 0,
                class: "logo-container m-0"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    style: _normalizeStyle({backgroundImage: `url(${getImage.value})`}),
                    class: "logo-container__image"
                  }, null, 4)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_sheet, {
                key: 1,
                class: "icon-container secondary-background-button-color"
              }, {
                default: _withCtx(() => [
                  _createVNode(Icon, { icon: "service-icon" })
                ]),
                _: 1
              })),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, {
                    class: "pa-3 ma-1 text-center sw-nav",
                    color: "white"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_1, _toDisplayString(state.service.name), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_2, [
                    _createTextVNode(_toDisplayString(getDuration.value) + " mins ", 1),
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "secondary-button-color" }, "|", -1)),
                    _createTextVNode(" " + _toDisplayString(state.service?.price_display), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, {
                    class: "d-flex align-center justify-center ga-2 mt-2",
                    color: "white"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Icon, { icon: "location-icon" }),
                      _createVNode(Icon, { icon: "phone-icon" }),
                      _createVNode(Icon, { icon: "video-icon" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "ma-auto mt-2 d-flex align-center justify-center" }, {
                default: _withCtx(() => [
                  (getCreatorDetails.value)
                    ? (_openBlock(), _createBlock(_component_v_sheet, {
                        key: 0,
                        class: "avatar-container",
                        onClick: _cache[0] || (_cache[0] = () => _unref(router).push({name: 'practitioner-bio', params:{ serviceId: _unref(route).params.id, practitionerId: state.service?.creator?.id, view: 'view' }}))
                      }, {
                        default: _withCtx(() => [
                          (getCreatorDetails.value.image?.file.file_path)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                style: _normalizeStyle({ backgroundImage: `url(${getCreatorDetails.value.image.file.file_path})` }),
                                class: "avatar-container__image"
                              }, null, 4))
                            : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(getInitials)(getCreatorDetails.value.first_name, getCreatorDetails.value.last_name).initials), 1))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, {
                    class: "px-3 ma-1 text-center overflow-y-auto",
                    color: "white",
                    height: "100"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(state.service?.description), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_sheet, {
            class: "mt-1",
            width: "100%"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    class: "text-center",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_sheet, {
                        class: "px-3 ma-1 text-center sw-nav",
                        color: "white"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(ButtonBase, {
                            "custom-class": ['primary-button text-white mb-3'],
                            text: "Book Now",
                            width: "100%",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({name: 'book-service', params: { id: state.service.id }})))
                          }),
                          _createVNode(ButtonBase, {
                            "custom-class": ['white-btn font-size-12-600'],
                            text: "Add to Cart",
                            width: "100%",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (addService()))
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})